// Unpublished Work © 2026 Deere & Company.

import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ConfigContext } from "../../../../context/ConfigContext";
import { useDelegateContext } from "../../../../context/DelegateContext/DelegateContext";

const DelegateBanner = () => {
  const theme = useTheme();
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { ENABLE_DELEGATE_LOGIN, ENABLE_REMOVE_DASHBOARD_TAB } =
    useContext(ConfigContext);
  const { isDelegating, delegatedUserId, clearDelegatedUser } =
    useDelegateContext();

  if (!ENABLE_DELEGATE_LOGIN || !isDelegating) {
    return null;
  }

  const handleStopDelegation = () => {
    clearDelegatedUser();
    navigate(ENABLE_REMOVE_DASHBOARD_TAB ? "/home" : "/my-dashboard");
  };

  return (
    <Box
      data-testid="delegate-banner"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.tokens.FuelSpacing2,
        backgroundColor: "#FEE7C4",
        padding: `${theme.tokens.FuelSpacing1} ${theme.tokens.FuelSpacing4}`,
        width: "100%",
        height: "36px",
      }}
    >
      <SwapHorizIcon
        fontSize="small"
        sx={{
          color: theme.tokens.FuelColorTextPrimary,
        }}
      />
      <Typography
        data-testid="delegate-banner-message"
        sx={{
          color: theme.tokens.FuelColorTextPrimary,
          fontWeight: theme.tokens.FuelFontWeightSemibold,
          fontSize: theme.tokens.FuelFontSizeSm,
          lineHeight: theme.tokens.FuelLineHeightSm,
        }}
      >
        {t("delegateBanner.message")} {delegatedUserId?.toUpperCase()}
      </Typography>
      <Button
        variant="secondary"
        startIcon={<HighlightOffIcon fontSize="small" />}
        onClick={handleStopDelegation}
        sx={{
          border: `1px solid ${theme.tokens.FuelColorGreen700}`,
          backgroundColor: theme.tokens.FuelColorGreen50,

          "&:hover": {
            border: `1px solid ${theme.tokens.FuelColorGreen700}`,
            backgroundColor: theme.tokens.FuelColorGreen100,
          },
        }}
        data-testid="delegate-banner-stop-button"
      >
        {t("delegateBanner.stopButton")}
      </Button>
    </Box>
  );
};

export default DelegateBanner;
